import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class WorkAssignUserModel extends BaseModel {

    constructor() {
        super({
                name: "work_assign_user",
                tableName: 'work_assign_user',
                label: "Công việc được giao",
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: "id",
                    display: false
                },
                work_id: { 
                    name: 'work_id',
                    display: false
                },
                uid: { 
                    name: 'uid',
                    display: false
                },
            },
            )
    }

}